/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal';
import './BulkStatusModal.scss';

const BulkStatusModal = ({ selectedRows, statuses, onUpdate, onCancel, isLoading }) => {
  const [newStatus, setNewStatus] = useState('');
  const [comment, setComment] = useState('');
  const [errors, setErrors] = useState({});

  const selectedCount = Array.isArray(selectedRows) ? selectedRows.length : 0;
  const dialogTitle = 'Update status';

  const handleStatusChange = (evt) => {
    setNewStatus(evt.target.value);
    setErrors((prev) => ({
      ...prev,
      status: '',
    }));
  };

  const handleCommentChange = (evt) => {
    setComment(evt.target.value);
    setErrors((prev) => ({
      ...prev,
      comment: '',
    }));
  };

  const handleUpdate = () => {
    const nextErrors = {};

    if (!newStatus) {
      nextErrors.status = 'Please select request status';
    }

    if (!comment.trim()) {
      nextErrors.comment = 'Please enter comment';
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    onUpdate(newStatus, comment.trim());
  };

  const dialogContent = (
    <div className="bulk-status-modal-content">
      <div className="bulk-status-summary">
        <span className="bulk-status-summary-label">No. of POs Selected</span>
        <span className="bulk-status-summary-value">{selectedCount}</span>
      </div>

      <div className="form-group">
        <label htmlFor="request_status">Request Status</label>
        <select
          id="request_status"
          value={newStatus}
          onChange={handleStatusChange}
          className={`form-control ${errors.status ? 'is-invalid' : ''}`}
          disabled={isLoading}
        >
          <option value="">Select</option>
          {statuses.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>
        {errors.status && <span className="invalid-feedback">{errors.status}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="request_comment">Comment<span className="required">*</span></label>
        <textarea
          id="request_comment"
          value={comment}
          onChange={handleCommentChange}
          className={`form-control ${errors.comment ? 'is-invalid' : ''}`}
          disabled={isLoading}
          placeholder="Enter..."
          rows={3}
        />
        {errors.comment && <span className="invalid-feedback">{errors.comment}</span>}
      </div>
    </div>
  );

  return (
    <FormDialog
      title={dialogTitle}
      open={true}
      handleClose={onCancel}
      dialogBodycontent={dialogContent}
      button1="Cancel"
      button2={isLoading ? 'Updating...' : 'Save'}
      button1Action={onCancel}
      button2Action={handleUpdate}
      button2Disabled={isLoading}
      dialogCss="bulk-status-dialog"
    />
  );
};

BulkStatusModal.propTypes = {
  selectedRows: PropTypes.array,
  statuses: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

BulkStatusModal.defaultProps = {
  selectedRows: [],
  statuses: [],
  isLoading: false,
};

export default BulkStatusModal;
